import {BaseComponent} from "../../Library/BaseComponent";
import {Component, Input, OnInit, ViewChild} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {MasterDataService} from "../../Services/MasterDataService";
import {RecurrenceQuery} from "../../Models/RequestModels";
import {cloneDeep} from "lodash";
import {RecurrenceSearchResult} from "../RecurrenceSearchResult/RecurrenceSearchResult";
import {RecurrenceSearch_GroupBy} from "../../Models/EnumModels";

@Component({
    selector: 'RecurrenceSearchGroup',
    templateUrl: './RecurrenceSearchGroup.html'
})
export class RecurrenceSearchGroup extends BaseComponent implements OnInit {
    @ViewChild('recurrenceSearchResult') searchResult: RecurrenceSearchResult;

    _RequestModel: RecurrenceQuery;
    _Model; // group response model
    ShowGroup = false;
    ChildInit = false;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService
    ) {
        super(translate, toastr, route, router, masterService);
    }

    @Input('Model') set Model(value) {
        this._Model = value;
        this.SetRequestModel();
    }

    get Model() {
        return this._Model;
    }

    @Input('RequestModel') set RequestModel(value: RecurrenceQuery) {
        this._RequestModel = cloneDeep(value);
        this.SetRequestModel();
    }

    get RequestModel() {
        return this._RequestModel;
    }

    ngOnInit() {
        super.ngOnInit();
    }

    OnToggle(): void {
        this.ShowGroup = !this.ShowGroup;
        if (this.ChildInit) {
            return;
        }
        this.searchResult.Show();
        this.ChildInit = true;
    }

    private SetRequestModel() {
        if (!this._Model || !this._RequestModel) {
            return;
        }
        if (this._RequestModel.GroupBy === RecurrenceSearch_GroupBy.None) {
            return;
        }
        const req = cloneDeep(this._RequestModel);
        const groupId = this.Model.Id;
        switch (req.GroupBy) {
            case RecurrenceSearch_GroupBy.CallDescriptions:
                req.CallDescriptions = [groupId];
                break;
            case RecurrenceSearch_GroupBy.CallCategories:
                // req.CallCategories = [groupId];
                break;
            case RecurrenceSearch_GroupBy.Dept:
                req.Departments = [groupId];
                break;
            case RecurrenceSearch_GroupBy.Location:
                req.Locations = [groupId];
                break;
            case RecurrenceSearch_GroupBy.Property:
                req.Properties = [groupId];
                break;
        }
        req.GroupBy = RecurrenceSearch_GroupBy.None;
        req.PageNumber = 1;
        req.PageSize = 10;
        this._RequestModel = req;
    }
}
